<form [formGroup]="itemForm" class="form-horizontal" novalidate>
  <div class="row">
    <div class="col-md-12">
      <fieldset class="border p-3 mt-2">
        <div class="row">
          <div class="col-2">
            <div style="height: 330px;">
              <!-- <img src="../../../assets/img/examples/example1-300x300.jpg" height="100" alt="" class="mb-2">
              <img src="../../../assets/img/examples/example1-300x300.jpg" height="100" alt="" class="mb-2">
              <img src="../../../assets/img/examples/example1-300x300.jpg" height="100" alt="" class="mb-2"> -->
            </div>
          </div>
          <div class="col-10">
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <ng-select [items]="catagories" bindLabel="Code" placeholder="Select Category" bindValue="ID"
                    formControlName="Category" (change)="getGroups($event)">
                  </ng-select>
                  <!-- <label for="brandName" class="f-12 font-weight-bold">Category</label> -->
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <!-- <label for="brandName" class="f-12 font-weight-bold">Group</label> -->
                  <ng-select [items]="groups" bindLabel="Code" placeholder="Select Group" bindValue="ID"
                    formControlName="Group" (change)="getBrands($event)">
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <!-- <label for="brandName" class="f-12 font-weight-bold">Brand</label> -->
                  <ng-select [items]="brands" bindLabel="Code" placeholder="Select Brand" bindValue="ID"
                    formControlName="Brand" (change)="getModels($event)">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <label for="brandName" class="f-12 font-weight-bold">Model</label>
                  <ng-select [items]="models" bindLabel="Code" placeholder="Select Model" bindValue="ID"
                    formControlName="Model" (change)="getColorCapacity($event)">
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <label for="brandName" class="f-12 font-weight-bold">Temperature Color</label>
                  <ng-select [items]="temparatureColors" bindLabel="Code" placeholder="Select Color" bindValue="ID"
                    formControlName="TemparatureColor">
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <label for="brandName" class="f-12 font-weight-bold">Body Color</label>
                  <ng-select [items]="bodyColors" bindLabel="Code" placeholder="Select Color" bindValue="ID"
                    formControlName="BodyColor">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <label for="brandName" class="f-12 font-weight-bold">Capacity</label>
                  <ng-select [items]="capacity" bindLabel="Code" placeholder="Select Capacity" bindValue="ID"
                    formControlName="Capacity" (change)="getItems()">
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <label for="brandName" class="f-12 font-weight-bold">Item</label>
                  <ng-select [items]="items" bindLabel="Code" placeholder="Select Item" bindValue="ID"
                    formControlName="ItemID" (change)="getItemLabel($event)">
                  </ng-select>
                </div>
              </div>
              <div class="col-4"></div>
              <div class="col-4"></div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="font-weight-bold pt-3 pb-3 text-center">
                  - OR -
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <label for="itemCode" class="f-13 font-weight-bold">Item Code</label>
                  <ng-select [items]="itemCodes" bindLabel="Code" placeholder="Search Item" bindValue="ID"
                    formControlName="ItemCode_ItemName" [loading]="loading" (search)="getItemCodes($event)"
                    (change)="getItemLabelSearch($event)">
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <label for="itemName" class="f-13 font-weight-bold">Item Name</label>
                  <input type="text" class="form-control" id="itemName" formControlName="ItemName"
                    placeholder="Item Name" readonly>
                </div>
              </div>
            </div>
          </div>
        </div>
    </fieldset>
  </div>
  </div>
</form>